// extracted by mini-css-extract-plugin
export default {"headerRow":"SavedViews-module__headerRow--jnjtg","savedViewsList":"SavedViews-module__savedViewsList--LrdhJ"};